import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { take } from 'rxjs';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';

@Component({
  selector: 'app-after-order-screen',
  templateUrl: './after-order-screen.component.html',
  styleUrls: ['./after-order-screen.component.scss']
})
export class AfterOrderScreenComponent implements OnInit {

  paymentState = {
    status: 0, // 0 === pending || 1 === success || 2 === failed
  }
  orderSuccessData: any;
  orderDetails;
  isPaymentConfirm: boolean = false;
  redirectByWA: boolean = false;

  getInterRegionalRoute(): string {
    const country = localStorage.getItem('country');
    return country === 'Ghana' ? '/inter-regional' : '/inter-state';
  }

  constructor(
    private _activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private _auth: AuthServiceLocal,
    private _FacebookApiService: FacebookApiService,
    private _route: Router
  ) {

    if (localStorage.getItem('redirectByWA')) {
      this.redirectByWA = true;
    } else {
      this.redirectByWA = false;
    }


  }

  ngOnInit(): void {


    console.log("hello in after order screen");

    this._activatedRoute.params.pipe(take(1)).subscribe((res: any) => {
      console.log("res", res);
      this.orderDetails = res;

      if (res.status == 'success') {
        console.log("hello in after order screen sucess");



        this.paymentState.status = 0;

        if (this.orderDetails.orderType == 'standard' || this.orderDetails.orderType == 'standard-heavy') {
          this.confirmPayment();
          // this.paymentState.status = 2;
        } else if (this.orderDetails.orderType == 'bulk') {

          this.confirmPaymentBulk();
        }
      } else {

        this.paymentState.status = 0;

        if (this.orderDetails.orderType == 'standard' || this.orderDetails.orderType == 'standard-heavy') {
          this.confirmPayment();
        } else if (this.orderDetails.orderType == 'bulk') {
          this.confirmPaymentBulk();
        }
      }

    })
  }

  onUpdatePaymentInApi() {
    // window.open(`https://wa.me/${localStorage.getItem('country') == 'Ghana' ? '+233530460178' : '+2349166329008'}`, '_self');

    // if(this.orderDetails.orderType == 'standard'){
    //   if(this.orderDetails.status == 'success'){
    //     this._route.navigate(['orders/detail/' + this.orderDetails?.orderId]);
    //   }else{
    //     if(this.orderDetails?.orderId){
    //       this._route.navigate(['/standard'], {queryParams : {
    //         failback : this.orderDetails?.orderId
    //       }});
    //     }else{
    //       this._route.navigate(['/']);
    //     }
    //   } 
    // }
    // else if(this.orderDetails.orderType == 'bulk'){
    //   if(this.orderDetails.status == 'success'){
    //     this._route.navigate(['orders/bulkdetail/' + this.orderDetails?.orderId]);
    //   }else{
    //     this._route.navigate(['/']);
    //   }
    // }
    if (this.orderDetails.orderType == 'standard') {
      if (this.paymentState.status == 1) {
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${localStorage.getItem('country') == 'Ghana'
              ? '+233530460178'
              : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          this._route.navigate(['orders/detail/' + this.orderDetails?.orderId]);
        }
      } else if (
        this.paymentState.status == 2 ||
        this.paymentState.status == 0
      ) {
        this._route.navigate(['/standard']);
      }
    } else if (this.orderDetails.orderType == 'bulk') {
      if (this.paymentState.status == 1) {
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${localStorage.getItem('country') == 'Ghana'
              ? '+233530460178'
              : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          this._route.navigate([
            'orders/bulkdetail/' + this.orderDetails?.orderId,
          ]);
        }
      } else if (
        this.paymentState.status == 2 ||
        this.paymentState.status == 0
      ) {
        this._route.navigate(['/bulk']);
      }
    } else if (this.orderDetails.orderType == 'standard-heavy') {
      if (this.paymentState.status == 1) {
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${localStorage.getItem('country') == 'Ghana'
              ? '+233530460178'
              : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          this._route.navigate([
            'orders/heavydetail/' + this.orderDetails?.orderId,
          ]);
        }
      } else if (
        this.paymentState.status == 2 ||
        this.paymentState.status == 0
      ) {
        this._route.navigate(['/standard-heavy']);
      }
    } else if (this.orderDetails.orderType == 'inter-regional') {
      if (this.paymentState.status == 1) {
        if (this.redirectByWA) {
          window.open(
            `https://wa.me/${localStorage.getItem('country') == 'Ghana'
              ? '+233530460178'
              : '+2349166329008'
            }`,
            '_self'
          );
        } else {
          this._route.navigate([
            'orders/interdetail/' + this.orderDetails?.orderId,
          ]);
        }
      } else if (
        this.paymentState.status == 2 ||
        this.paymentState.status == 0
      ) {
        this._route.navigate([this.getInterRegionalRoute()]);
      }
    }

  }

  confirmPayment() {
    const payload = {
      transactionId: this.orderDetails?.transactionId,
      status: this.orderDetails?.status,
      sessionId: "",
      orderId: this.orderDetails?.orderId
    }

    this._auth.standardOrderPaymentConfirm(payload).subscribe((res: any) => {
      if (res.response == 1) {
        console.log("res==--->", res);
        this.orderSuccessData = res.data;
        this.paymentState.status = 1;
        this._auth.callgetDashboardDataAPI()

        if (this.orderDetails.orderType == 'standard') {
          if (localStorage.getItem('PENDINGORDERDATA')) {
            this.addFbEvent('standard')
            this.addGoogleTags('standard');
            localStorage.removeItem('PENDINGORDERDATA');
          }
        } else if (this.orderDetails.orderType == 'standard-heavy') {
          if (localStorage.getItem('PENDINGHEAVYORDERDATA')) {
            this.addFbEvent('standardheavy')
            this.addGoogleTags('standard-heavy');
            localStorage.removeItem('PENDINGHEAVYORDERDATA');
          }
        }

      } else {
        this.paymentState.status = 2;
      }
      // console.log("res standardOrderPaymentConfirm", res); 
    })

  }


  confirmPaymentBulk() {
    const payload = {
      transactionId: this.orderDetails?.transactionId,
      status: this.orderDetails?.status,
      sessionId: "",
      orderId: this.orderDetails?.orderId,
      currency: localStorage.getItem('country') == 'Ghana' ? 'GHS' : 'NGN'
    }

    console.log("payload", payload);
    this._auth.bulkOrderPaymentConfirm(payload).subscribe((res: any) => {
      if (res.response) {
        console.log("resbulkOrderPaymentConfirm", res.data);
        this.orderSuccessData = res.data
        this.paymentState.status = 1;

        this._auth.callgetDashboardDataAPI()
        if (localStorage.getItem('PENDINGBULKORDERDATA')) {
          this.addFbEvent('bulk');
          this.addGoogleTags('bulk');
          localStorage.removeItem('PENDINGBULKORDERDATA');
        }
      } else {
        this.paymentState.status = 2;
      }
    })
  }

  addFbEvent(type) {
    const orderData = {
      selectedDeliveryMethod: null,
      orderDoc: null,
      resData: this.orderSuccessData
    }
    this._FacebookApiService.sendPurchaseEvent(type, true, orderData)
  }

  addGoogleTags(type) {

    // get user data
    const user = JSON.parse(localStorage.getItem('authUser'));

    if (type == 'standard' || type == 'standard-heavy') {
      // Add the event snippet for Purchase Conversion
      const item = this.orderSuccessData?.dropPoints?.length ? this.orderSuccessData?.dropPoints.map(((item, i) => {
        return {
          'item_id': item?.item_id,
          'item_name': item?.item_name,
          'affiliation': item?.affiliation,
          'coupon': this.orderSuccessData?.coupon,
          'discount': item?.discount,
          'index': i || '',
          'item_brand': "Phlenu",
          'item_category': item?.item_category,
          'price': item?.price,
          'quantity': i + 1
        }
      })) : [];
      // Adding data to the GTM Data Layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'purchase',
        'name': user.firstName,
        'email': user.email,
        'phone': user.phoneCode + '' + user.phone,
        'ecommerce': {
          'transaction_id': this.orderSuccessData?.transaction_id || '',
          'value': this.orderSuccessData?.value,
          'tax': this.orderSuccessData?.tax,
          'shipping': this.orderSuccessData?.shipping,
          'currency': this.orderSuccessData?.currency,
          'price': this.orderSuccessData?.price,
          'coupon': this.orderSuccessData.coupon,
          'items': JSON.parse(JSON.stringify(item))
        }
      });

    } else {
      // bulk

      // Add the event snippet for Purchase Conversion
      const item = this.orderSuccessData?.dropPoints?.length ? this.orderSuccessData.dropPoints.map(((item, i) => {
        return {
          'item_id': item?.item_id,
          'item_name': item?.item_name,
          'affiliation': item?.affiliation,
          'coupon': this.orderSuccessData?.coupon,
          'discount': item?.discount,
          'index': i || '',
          'item_brand': 'Phlenu',
          'item_category': item?.item_category,
          'price': item?.price,
          'quantity': i + 1
        }
      })) : [];

      // Adding data to the GTM Data Layer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'purchase',
        'name': user.firstName,
        'email': user.email,
        'phone': user.phoneCode + '' + user.phone,
        'ecommerce': {
          'transaction_id': this.orderSuccessData?.transaction_id || '',
          'value': this.orderSuccessData?.value,
          'tax': this.orderSuccessData?.tax,
          'shipping': this.orderSuccessData?.shipping,
          'currency': this.orderSuccessData?.currency,
          'price': this.orderSuccessData?.price,
          'coupon': this.orderSuccessData.coupon,
          'items': JSON.parse(JSON.stringify(item))
        }
      });
    }
  }

}
